export default {
  getSurveys (state) {
    return state.surveys
  },
  getSurvey (state) {
    return state.survey
  }
}



// WEBPACK FOOTER //
// ./src/store/module/survey/getters.js